import { FilterSettingsModel, IFilter, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-react-grids';

export const getSettingsLink = (navData) => {

  const selectionSettings: SelectionSettingsModel = {
    persistSelection: true
  };
  const isPrimaryKey = true;

  const customAttributes: any = { class: 'customcss' };
  // infiniteOptions: InfiniteScrollSettingsModel = { enableCache: true };
  const filterMenu: IFilter = {
    type: 'CheckBox',
    operator: 'contains'
  };
  const pageSettings: PageSettingsModel = {
    pageSize: navData?.widgetData?.pageSize ?? '20',
    pageSizes: ['5', '10', '20', '50']
  };

  const pageSettingsInfinite: PageSettingsModel = {
    pageSize: 100
  };


  const filterSettingsMenu: FilterSettingsModel = {
    showFilterBarOperator: true,
    mode: 'Immediate',
    immediateModeDelay: 400
  };
  const filterSettingsExcel: FilterSettingsModel = {
    showFilterBarOperator: true,
    mode: 'Immediate',
    immediateModeDelay: 400,
    type: 'Excel'
  };

  return {
    pageSettingsInfinite,
    filterMenu,
    pageSettings,
    customAttributes,
    selectionSettings,
    filterSettingsMenu,
    isPrimaryKey,
    filterSettingsExcel
  };
};